const smtPqPhotonQSection = {
    description: {
        color: {
            default: 'gray.900',
            _dark: 'gray.400'
        },
    }
}

export default smtPqPhotonQSection;